"use client";
import { ReactNode } from "react";
import { useModal } from "../_primitives/Modal/ModalRoot/ModalRoot";

interface MediaInfoModalDismissProps {
  className?: string;
  children: ReactNode;
}

// Closes the modal when the backdrop is clicked or Escape is pressed.
const MediaInfoModalDismiss = ({
  className,
  children,
}: MediaInfoModalDismissProps) => {
  const { setOpen } = useModal();

  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div
      className={className}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setOpen(false);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          setOpen(false);
        }
      }}
    >
      {children}
    </div>
  );
};

export default MediaInfoModalDismiss;
